export default async function tryDynamicRedirectOrShowError(error: MaybeRef<unknown>) {
	const normalizedError = unref(error);
	const route = useRoute();
	const {runWithContext} = useNuxtApp();

	let redirect;
	try {
		redirect = await $fetch(`/nuxtApi/fetchDynamicRedirect?from=${encodeURIComponent(route.fullPath)}`);
	} catch (fetchError: any) {
		// If fetchDynamicRedirect fails (e.g., 429), use that error
		// Plugin will automatically extract correct statusCode
		return runWithContext(() => useShowError(fetchError || normalizedError || {statusCode: 500}));
	}

	if (!redirect || route.path === redirect?.urlTo) {
		return runWithContext(() => useShowError(normalizedError ?? {statusCode: 404}));
	}

	const redirectQueryParams = new URLSearchParams(redirect.urlTo.split('?')[1]);
	Object.keys(route.query).forEach((query) => {
		if (redirectQueryParams.has(query)) {
			delete route.query[query];
		}
	});

	return runWithContext(() => navigateTo(
		{path: dropUnderscoreRouteParts(redirect.urlTo), query: route.query},
		{redirectCode: Number(redirect.httpCode) || 301, external: true},
	));
}
